<template>
  <div class="back">
    <div class="header">
      <img src="../png/qssyLogo.jpg" style="width: 160px;height:55px;float: left;margin-left: 13%;  padding-top: 0.8% "/>
<!--      <p>|</p>-->
<!--      <span style="float: left;font-size: 24px;padding-top: 2%"> | 廉洁举报平台</span>-->
      <div style="padding-top:2.8%;float: right;padding-right: 5%">
<!--        <span class="topRightButton"><a @click="toForm">我要举报</a></span>-->
        <span class="topRightButton"><a class="topRightButtonA" @click="openWx">微信公众号举报</a></span>
        <span class="topRightButton"> | <a class="topRightButtonA" @click="openPhone">专线电话举报</a></span>
<!--        <span class="topRightButton"> | <a class="topRightButtonA" @click="openPhone">专线电话举报</a></span>-->
        <span class="topRightButton"> | <a class="topRightButtonA" @click="openEmail">电子邮箱举报</a></span>
        <span class="topRightButton"> | <a class="topRightButtonA" @click="openMail">信函举报</a></span>
        <span class="topRightButton">| <a class="topRightButtonA" @click="toProblem">常见问题</a></span>
      </div>
    </div>
    <div class="second">
<!--      <p class="bigTitle">廉洁举报平台</p>-->
<!--      <p class="smallDetail">举报保密 实名优先 查实有奖</p>-->
      <el-button class="submitButton" style="height: 50px;font-size: 28px;margin-top: 14.2%"
                 size="big" type="primary" @click="toForm">我 要 举 报</el-button>
<!--      <div style="width: 30%;margin-left:37.5%;height: 10%;margin-top: 1%" >-->
<!--        <div class="logoOne" @click="openMail">-->
<!--          <div class="grid-content" >-->
<!--            <img src="../png/emailw.png"  />-->
<!--          </div>-->
<!--          <div>-->
<!--            电子邮箱-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="logoOne" @click="openPhone">-->
<!--          <div class="grid-content">-->
<!--            <img src="../png/phonew.png" />-->
<!--          </div>-->
<!--          <div >-->
<!--            专线电话-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="logoOne" @click="openPhone">-->
<!--          <div class="grid-content" >-->
<!--            <img src="../png/code.png"  />-->
<!--          </div>-->
<!--          <div>-->
<!--            微信公众号-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="logoOne" @click="openMail">-->
<!--          <div class="grid-content" >-->
<!--            <img src="../png/email.png"  />-->
<!--          </div>-->
<!--          <div style="color: black">-->
<!--            举报信函-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="third">
      <div style="padding-top: 2%; opacity: 1;z-index: 2">
        <el-row :gutter="20" style="margin-bottom: 20px">
          <el-col :span="3">
            <div class="grid-content"></div>
          </el-col>
          <el-col :span="7" style="margin-left: 0%">
            <img src="../png/policyw.png" style="float: left;"/>
            <div style="font-size: 24px;width: 160px"><b>阳光政策</b></div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content"></div>
          </el-col>
          <el-col :span="6" style="margin-left: -1.5%">
            <img src="../png/slfw1.png" style="float: left"/>
            <div style="font-size: 24px;width: 160px"><b>受理范围</b></div>
          </el-col>
        </el-row>
          <el-row :gutter="20">
            <el-col :span="3">
              <div class="grid-content"></div>
            </el-col>
            <el-col :span="3" style="margin-left: 1%;" >
              <div class="grid-content" style="font-size: 17px">举报保密政策<br><br></div>
              <div class="grid-content" style="font-size: 17px;margin-top: 3%">实名优先政策<br><br></div>
              <div class="grid-content" style="font-size: 17px;margin-top: 3.5%">查实有奖政策</div>
              <div style="margin-top:10%;margin-left: 0%">
                <img src="../png/zy2.png" style="float: left;margin-left: -7%;margin-top: 2%"/>
                <div style="font-size: 24px;width: 140px;margin-left: 4%"><b>特别提醒</b></div>
              </div>

            </el-col>
            <el-col :span="7" style="margin-left: -2%;width: 28%">
              <div class="grid-item" style="text-align: left;">我们将严格保守举报人身份信息及举报内容，严格管控调查流程，依法保障举报人合法权益，严肃处理打击报复者。
              </div>
              <div class="grid-item" style="text-align: left;margin-top: 2%">我们鼓励举报人提供个人真实姓名及联系方式，尊重举报人的选择。对实名举报者，我们将优先受理并及时反馈处理结果。</div>
              <div class="grid-item" style="text-align: left;margin-top: 2%">凡实名举报且经查证属实的，我们将综合赃款赃物追回等情况，给予举报人最高1000万元人民币的奖励。
                <div class="grid-item" style="text-align: left;margin-top: 4%">举报人应对举报事项的真实性负责。对捏造事实，借举报诬告陷害的，我们将保留对举报者采取法律手段和纪律处分的权利。
                                </div>
              </div>
            </el-col>
            <el-col :span="2">
              <div class="grid-content"></div>
            </el-col>
            <el-col :span="9">
              <div class="grid-content " style="text-align: left;">举报平台受理以下类型的举报:</div>
              <el-row :gutter="20" style="margin-top: -0.5%">
                <el-col :span="8">
                  <div class="grid-item " style="text-align: left;">1. 索取或收受贿赂</div>
                  <div class="grid-item " style="text-align: left;">2. 违规收受礼品或招待</div>
                  <div class="grid-item " style="text-align: left;">3. 挪用或侵占公司资产</div>
                  <div class="grid-item " style="text-align: left;">4. 利用职权谋取私利</div>
                  <div class="grid-item " style="text-align: left;">5. 虚假报销</div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-item " style="text-align: left;">6. 违规参股、经营等损害公司利益</div>
                  <div class="grid-item " style="text-align: left;">7. 滥用职权或玩忽职守</div>
                  <div class="grid-item " style="text-align: left;">8. 侵犯商业秘密</div>
                  <div class="grid-item " style="text-align: left;">9. 违规招投标</div>
                  <div class="grid-item " style="text-align: left;">10. 其他违法违纪行为</div>

                </el-col>
              </el-row>
            </el-col>
          </el-row>
      </div>
    </div>
    <wx-code v-if="wxCodeOpen" :wxCodeOpen="wxCodeOpen" @refreshDataList="closeWx"></wx-code>
  </div>
</template>

<script>
import wxCode from './wxCode';
export default {
  name: "index",
  data(){
    return{
     wxCodeOpen:false
    }
  },
  components:{wxCode},
  methods:{
    toProblem(){
      this.$router.push({ name:'WebProblem'})
    },
    toForm(){
      this.$router.push({ name:'WebForm'})
    },
    openTss() {
      let msg='登录集团官网www.tssgroup.com.cn，点击“廉洁青山”进入“青山实业廉洁举报平台”；'
      this.$alert(msg, '官网平台', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        callback: action => {
        }
      });
    },
    openPhone() {
      let msg='&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;座机：0577-86887787<br>' +
        '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;手机：13336919977<br>'+
        '&nbsp;&nbsp;&nbsp;（&nbsp;夏令：8:30-17:30； 冬令：8:30-17:00&nbsp;）'
      this.$alert(msg, '专线电话', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        callback: action => {
        }
      });
    },
    openEmail() {
      let msg='&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;jubao@tssgroup.com.cn';
      this.$alert(msg, '举报受理邮箱', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        callback: action => {
        }
      });
    },
    openMail() {
      let msg='&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;方式一：投递信函至公司举报信箱；<br>'+
      '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;方式二：邮寄信函至浙江省温州市龙湾区龙祥路2666号青山实业董事局监察安全委员会廉洁监察部（收）。';
      this.$alert(msg, '信函举报', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        callback: action => {
        }
      });
    },
    openWx(){
      this.wxCodeOpen=true;
    },
    closeWx(){
      this.wxCodeOpen=false;
    }
  }
}
</script>

<style scoped>
.back{    /* div的CSS样式 */
  position : absolute;
  top:0;
  left: 0;
  width : 100%;
  height :100%;
  /*background: url("static/png/back.jpg");*/
  background-image: url("../png/back3.jpg");
  background-size:100% 100%;
}
.header{
  width: 100%;
  height: 11%;
  background: white;
}
.second{
  height: 43%;
}
.third{
  background-color: rgba(0, 0, 0, 0.7);
  /*background-color: black;*/
  /*opacity: 0.5;*/
  height: 46%;
  color:white;
}
.bigTitle{
  font-size: 100px;
  color: white;
  /* font-family: 华光魏体_CNKI; */
}
.smallDetail{
  margin-top: -3%;
  font-size: 30px;
  color: white;
}
.topRightButton{
  font-size: 14px;
  cursor: pointer;
  color: grey;
  /*padding-top: 20px*/

}
.topRightButtonA:hover{
  color: #4169E1
  /*padding-top: 20px*/

}
.logoOne{
  float:left;
  width: 20%;
  color: white;
}
.el-message--error{
  white-space:pre-line
}
.el-row {
  margin-bottom: 0px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
  font-size:15px;
  /*border: 1px solid black;*/
}

.grid-item{
  border-radius: 4px;
  min-height: 30px;
  font-size:14px;
  /* font-family: 雅黑; */
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.submitButton{
  width: 20%;
  /*background-color: red;*/
  /*background-color: #103274;*/
  /*border: 1px solid #103274;*/
}
</style>



// WEBPACK FOOTER //
// src/pages/web/index.vue